import React from "react";
import { getDate } from "../../../utils/formatDate"; 
import { BtnSua } from "./ChucNang/Sua/BtnSua";
import { BtnChiTiet } from "./ChucNang/ChiTiet/BtnChiTiet";
import { BtnXuatExcel } from "./ChucNang/InVaXuatExcel/BtnXuatExcel";
import { BtnIn } from "./ChucNang/InVaXuatExcel/BtnIn";

export const ContentTable = ({ dataSearch, listDanhSach, phanQuyen, onReload }) => {
    if (!listDanhSach || listDanhSach.length === 0) {
        return (
            <div className="custom-table-row no-data" style={{ minHeight: 56, justifyContent: 'center' }}>
                <p>Không có dữ liệu</p>
            </div>
        );
    }
    const pageStartIndex = (dataSearch.iPageIndex - 1) * dataSearch.iPageSize;
    return (
        <>
            {listDanhSach.map((item, index) => (
                <div key={item.KiemKeId} className="custom-table-row" style={{ minHeight: "56px", borderBottom: '1px solid #e0e0e0' }}>
                    <div className="custom-table-cell flex-basis-5 text-left" style={{ justifyContent: 'flex-start', fontWeight: 500 }}>
                        <span className="mobile-column-name color7-bold">STT</span>
                        <div className="center-wrapper color7-bold">
                            {pageStartIndex + index + 1}
                        </div>
                    </div>
                    <div className="custom-table-cell flex-basis-20 text-left" style={{ justifyContent: 'flex-start' }}>
                        <span className="mobile-column-name color7-bold">Loại Kiểm Kê</span>
                        <div className="center-wrapper">
                           {phanQuyen.chitiet ? <BtnChiTiet item={item} /> : item.LoaiKiemKe}
                        </div>
                    </div>
                    <div className="custom-table-cell flex-basis-30 text-left" style={{ justifyContent: 'flex-start' }}>
                        <span className="mobile-column-name color7-bold">Ngày tạo</span>
                        <div className="center-wrapper">
                            {getDate(item.CreateTime)}
                        </div>
                    </div>
                    <div className="custom-table-cell flex-basis-30 text-left" style={{ justifyContent: 'flex-start' }}>
                        <span className="mobile-column-name color7-bold">Người tạo</span>
                        <div className="center-wrapper">
                            {item.NguoiTao || ''}
                        </div>
                    </div>
                    <div className="custom-table-cell flex-basis-15" style={{ justifyContent: 'center' }}>
                        <div className="center-wrapper text-center" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                            {phanQuyen.sua && index === 0 && (
                                <BtnSua
                                    item={item}
                                    onReload={onReload}
                                />
                            )}
                            <BtnXuatExcel item={item} />
                            <BtnIn item={item} />
                        </div>
                    </div>
                </div>
            ))}
        </>
    );
};